import { DatePicker } from 'antd'
import locale from 'antd/es/date-picker/locale/pt_BR'
import clsx from 'clsx'
import dayjs from 'dayjs'
import { motion } from 'framer-motion'
import { CaretLeft, CheckCircle, Sliders, XCircle } from 'phosphor-react'
import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import Calender from '../../../../assets/icon/calender-icon.png'
import { Button } from '../../../../components/Button'
import { Select } from '../../../../components/Primitives/Select'
import { Radio } from '../../../../components/Radio'
import { getTotalMeetings } from '../../../../services/hooks/meetings/queries/useMeetingsOnDashboardQuery'
import { AssetAnalystMeetingsWithInfiniteScroll } from '../components/AssetAnalystMeetingsWithInfiniteScroll'
import { AssetMeetingsWithInfiniteScroll } from '../components/AssetMeetingsWithInfiniteScroll'
import { ClientMeetingsWithInfiniteScroll } from '../components/ClientMeetingsWithInfiniteScroll'
import { ExpertMeetingsWithInfiniteScroll } from '../components/ExpertMeetingsWithInfiniteScroll'
import { MeetingCard } from '../components/MeetingCard'
import { MeetingFilter } from '../components/MeetingFilter'
import { ResearcherMeetingsWithInfiniteScroll } from '../components/ResearcherMeetingsWithInfiniteScroll'

interface Column {
  field: string
  headerName: string
  isVisible?: boolean
}

export const Dashboard = () => {
  const [firstDate, setFirtsDate] = useState<any>()
  const [secondDate, setSecondDate] = useState<any>()
  const [startDate, setStartDate] = useState<number>(0)
  const [endDate, setEndDate] = useState<number>(4102444799000)
  const [totalMeetings, setTotalMeetings] = useState<any>()
  const [meetingFilter, setMeetingFilter] = useState<boolean>(false)
  const [filter, setFilter] = useState<boolean>(false)
  const [typeFilter, setTypeFilter] = useState<string>()
  const [filterByPeriodValue, setFilterByPeriodValue] = useState<string>('week')
  const [columns, setColumns] = useState<Column[]>([
    {
      field: 'client',
      headerName: 'Cliente',
      isVisible: true,
    },
    {
      field: 'expert',
      headerName: 'Expert',
      isVisible: true,
    },
    {
      field: 'researcher',
      headerName: 'Researcher',
      isVisible: true,
    },
    {
      field: 'asset',
      headerName: 'Asset',
      isVisible: false,
    },
    {
      field: 'analyst',
      headerName: 'Analista Asset',
      isVisible: false,
    },
  ])

  const disabledDate = (current: any) => {
    return current && current < dayjs(firstDate).endOf('day')
  }

  useEffect(() => {
    dayjs(firstDate).isAfter(dayjs(secondDate)) && setSecondDate(undefined)
  }, [firstDate])

  const openMobileFilterHandler = () => {
    setFilter(true)
    document.body.style.overflow = 'hidden'
    setTypeFilter(undefined)
  }

  const closeMobileFilterHandler = () => {
    setFilter(false)
    document.body.style.overflow = 'auto'
  }

  const filterByPeriod = () => {
    const getInitDate = () => {
      if (filterByPeriodValue === 'week') {
        return dayjs().subtract(1, 'week').toDate()
      }
      if (filterByPeriodValue === 'month') {
        return dayjs().subtract(1, 'month').toDate()
      }
      if (filterByPeriodValue === 'year') {
        return dayjs().subtract(1, 'year').toDate()
      }
    }

    const start = getInitDate()?.setHours(0, 0, 0, 0)
    const end = new Date().setHours(23, 59, 59, 999)

    start && setStartDate(start)
    setEndDate(end)
  }

  const handleGetTotalMeetingsByPeriod = async () => {
    const periodStart = new Date(firstDate.$d)
    const periodEnd = new Date(secondDate.$d)

    periodStart?.setHours(0, 0, 0, 0)
    periodEnd?.setHours(23, 59, 59, 999)

    const initDateTimestamp = periodStart?.getTime()
    const todayTimestamp = periodEnd?.getTime()

    setStartDate(initDateTimestamp)
    setEndDate(todayTimestamp)
  }

  const handleGetTotalMeetings = async () => {
    const startDateString = JSON.stringify(startDate)
    const endDateString = JSON.stringify(endDate)

    const response = await getTotalMeetings({
      startDate: startDateString,
      endDate: endDateString,
    })

    setTotalMeetings(response)
  }

  const handleFilterMobile = () => {
    typeFilter === 'period'
      ? filterByPeriod()
      : handleGetTotalMeetingsByPeriod()

    closeMobileFilterHandler()
  }

  useEffect(() => {
    handleGetTotalMeetings()
  }, [endDate])

  return (
    <div className="py-8">
      {/* Filter web */}
      <div className="hidden lg:flex lg:gap-28 ">
        <div>
          <p className="mb-6">Filtrar por período</p>
          <div className="flex gap-4">
            <div className="w-[203px]">
              <Select
                defaultValue="week"
                onValueChange={(value) => setFilterByPeriodValue(value)}
                options={[
                  { label: 'Última semana', value: 'week' },
                  { label: 'Último mês', value: 'month' },
                  { label: 'Último ano', value: 'year' },
                ]}
              />
            </div>
            <Button
              variant="outline"
              className="lg:text-sm h-[46px]"
              onClick={filterByPeriod}
            >
              Pesquisar
            </Button>
          </div>
        </div>

        <div>
          <p className="mb-6">Filtrar por data</p>
          <div className="flex items-center gap-4">
            <DatePicker
              className="h-[46px]"
              locale={locale}
              format="DD/MM/YYYY"
              onChange={(value) => setFirtsDate(value)}
              value={firstDate}
            />
            Até
            <DatePicker
              className="h-[46px]"
              locale={locale}
              format="DD/MM/YYYY"
              disabledDate={disabledDate}
              onChange={(value) => setSecondDate(value)}
              value={secondDate}
            />
            <Button
              variant="outline"
              className="lg:text-sm h-[46px]"
              onClick={handleGetTotalMeetingsByPeriod}
            >
              Pesquisar
            </Button>
          </div>
        </div>
      </div>

      {/* Filter mobile */}
      <div className="lg:hidden">
        <Button variant="outline" onClick={openMobileFilterHandler}>
          <Sliders size={18} />
          Filtrar dados
        </Button>
      </div>

      {filter && (
        <>
          {createPortal(
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed top-0 bottom-0 left-0 right-0 z-50 p-6 overflow-y-auto bg-white scrollbar"
            >
              <button
                aria-label="Voltar"
                className="mb-8"
                onClick={closeMobileFilterHandler}
              >
                <CaretLeft size={24} className="text-grey-700" />
              </button>

              <>
                <strong className="block mb-8 text-grey-900">Filtros</strong>

                <div
                  className={clsx('flex flex-col', {
                    'h-[calc(100vh_-_196px)] justify-between':
                      typeFilter !== 'date',
                    'h-[calc(100vh_-_70px)] gap-[calc(100vh_-_360px)]':
                      typeFilter === 'date',
                  })}
                >
                  <Radio.Root
                    name="filterType"
                    onValueChange={(value) => setTypeFilter(value)}
                  >
                    <div className="flex flex-col gap-4">
                      <Radio.Item id="period" value="period">
                        <Radio.Label htmlFor="period">
                          Filtrar por período
                        </Radio.Label>
                      </Radio.Item>

                      {typeFilter === 'period' && (
                        <Select
                          defaultValue="week"
                          onValueChange={(value) =>
                            setFilterByPeriodValue(value)
                          }
                          options={[
                            { label: 'Última semana', value: 'week' },
                            { label: 'Último mês', value: 'month' },
                            { label: 'Último ano', value: 'year' },
                          ]}
                        />
                      )}

                      <Radio.Item id="date" value="date">
                        <Radio.Label htmlFor="date">
                          Filtrar por data
                        </Radio.Label>
                      </Radio.Item>

                      {typeFilter === 'date' && (
                        <div>
                          <div className="flex items-center gap-2">
                            <DatePicker
                              className="h-[44px]"
                              placement="bottomLeft"
                              locale={locale}
                              format="DD/MM/YYYY"
                              onChange={(value) => setFirtsDate(value)}
                              value={firstDate}
                            />
                            até
                            <DatePicker
                              className="h-[44px]"
                              placement="bottomRight"
                              locale={locale}
                              format="DD/MM/YYYY"
                              onChange={(value) => setSecondDate(value)}
                              value={secondDate}
                              disabledDate={disabledDate}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </Radio.Root>

                  <Button fullWidth onClick={handleFilterMobile}>
                    Aplicar
                  </Button>
                </div>
              </>
            </motion.div>,
            document.body
          )}
        </>
      )}

      <div className="flex gap-1 mt-4 mb-6 sm:gap-4 lg:mt-14">
        <MeetingCard
          title="Reuniões concluídas"
          data={totalMeetings?.concludedMeetings || 0}
          icon={<CheckCircle size={66} className="text-secondary-dark" />}
        />
        <MeetingCard
          title="Reuniões agendadas"
          data={totalMeetings?.pendingMeetings || 0}
          icon={<img src={Calender} />}
        />
        <MeetingCard
          title="Reuniões canceladas"
          data={totalMeetings?.canceledMeetings || 0}
          icon={<XCircle size={66} className="text-secondary-dark" />}
        />
      </div>

      <div className="flex flex-col">
        <div className="relative flex-1 mb-4 ml-auto">
          <Button variant="outline" onClick={() => setMeetingFilter(true)}>
            <Sliders size={18} />
            Filtrar reuniões
          </Button>

          <MeetingFilter
            columns={columns}
            isOpen={meetingFilter}
            onClose={() => setMeetingFilter(false)}
            onConfigureColumns={setColumns}
          />
        </div>

        <div className="w-full flex flex-col lg:flex-row gap-4">
          {columns[0].isVisible && (
            <ClientMeetingsWithInfiniteScroll
              startDate={startDate}
              endDate={endDate}
            />
          )}
          {columns[1].isVisible && (
            <ExpertMeetingsWithInfiniteScroll
              startDate={startDate}
              endDate={endDate}
            />
          )}
          {columns[2].isVisible && (
            <ResearcherMeetingsWithInfiniteScroll
              startDate={startDate}
              endDate={endDate}
            />
          )}
          {columns[3].isVisible && (
            <AssetMeetingsWithInfiniteScroll
              startDate={startDate}
              endDate={endDate}
            />
          )}
          {columns[4].isVisible && (
            <AssetAnalystMeetingsWithInfiniteScroll
              startDate={startDate}
              endDate={endDate}
            />
          )}
        </div>
      </div>
    </div>
  )
}
